const hours = getSupportHoursForToday();
const $msg = $('.helpFooter .online p');
const $msghelpSidebar = $('.helpSidebar .online p');
const $tel = $('footer#footer .contact-box span.tel');
const $teltop = $('.top-navigation-contacts .project-phone');
const $teltopHeader = $('.responsive-tools .project-phone');
const $navigationActionsNumber = $('.navigationActions .customNumber');

$teltop.after('<span class="openHours">' + translation('openHour') + '</span>');
$navigationActionsNumber.find('.project-phone').after('<span class="openHours">' + translation('openHour') + '</span>');

const $contactUs = $('.online');

if (!hours) {
    // Zavřeno -> žádné hodiny nejsou definované
    $msg.removeClass('haveOpen').text(closeDaysText);
    $msghelpSidebar.removeClass('haveOpen').text(closeDaysText);
    $tel.removeClass('haveOpen');
    $teltop.removeClass('haveOpen');
    $teltopHeader.removeClass('haveOpen');
    $navigationActionsNumber.removeClass('haveOpen');
} else if (isSupportOnline(hours)) {
    // Otevřeno právě teď
    $msg.addClass('haveOpen').html(`Jsme tu do <span>${hours.close}</span>`);
    $msghelpSidebar.addClass('haveOpen').html(`Jsme tu do <span>${hours.close}</span>`);
    $tel.addClass('haveOpen');
    $teltop.addClass('haveOpen');
    $teltopHeader.addClass('haveOpen');
    $navigationActionsNumber.addClass('haveOpen');
} else {
    // Dnes je otevřeno, ale teď mimo provozní dobu
    $msg.removeClass('haveOpen').text(`Jsme tu ${hours.open} – ${hours.close}`);
    $msghelpSidebar.removeClass('haveOpen').text(`Jsme tu ${hours.open} – ${hours.close}`);
    $tel.removeClass('haveOpen');
    $teltop.removeClass('haveOpen');
    $teltopHeader.removeClass('haveOpen');
    $navigationActionsNumber.removeClass('haveOpen');
}

function updateSupportStatus() {
    const hours = getSupportHoursForToday();
    const $online = $('.text .online ');
    const $helpersidebar = $('.helpSidebar .online p');
    const $tel = $('.helpFooter .right ul span.tel');
    const $telEmptyCart = $('.contactUs .right ul span.tel');
    const customNumber = $('.customNumber .link');

    customNumber.append('<span class="openHours">' + translation('openHour') + '</span>');

    if (!hours) {
        $online.removeClass('haveOpen').text(closeDaysText);
        $helpersidebar.removeClass('haveOpen').text(closeDaysText);
        $tel.removeClass('haveOpen');
        $telEmptyCart.removeClass('haveOpen');
        customNumber.removeClass('haveOpen');
    } else if (isSupportOnline(hours)) {
        $online.addClass('haveOpen').html(`Jsme tu do <span>${hours.close}</span>`);
        $helpersidebar.addClass('haveOpen').html(`Jsme tu do <span>${hours.close}</span>`);
        $tel.addClass('haveOpen');
        $telEmptyCart.addClass('haveOpen');
        customNumber.addClass('haveOpen');
    } else {
        $online.removeClass('haveOpen').text(`Jsme tu ${hours.open} – ${hours.close}`);
        $helpersidebar.removeClass('haveOpen').text(`Jsme tu ${hours.open} – ${hours.close}`);
        $tel.removeClass('haveOpen');
        $telEmptyCart.removeClass('haveOpen');
        customNumber.removeClass('haveOpen');
    }
}

function fixedHolidays(year) {
    return [
        `${year}-01-01`,
        `${year}-05-01`,
        `${year}-05-08`,
        `${year}-07-05`,
        `${year}-07-06`,
        `${year}-09-28`,
        `${year}-10-28`,
        `${year}-11-17`,
        `${year}-12-24`,
        `${year}-12-25`,
        `${year}-12-26`,
    ];
}

function getEasterDates(year) {
    let f = Math.floor,
        a = year % 19,
        b = f(year / 100),
        c = year % 100,
        d = f(b / 4),
        e = b % 4,
        g = f((8 * b + 13) / 25),
        h = (19 * a + b - d - g + 15) % 30,
        i = f(c / 4),
        k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = f((a + 11 * h + 22 * l) / 451),
        month = f((h + l - 7 * m + 114) / 31),
        day = ((h + l - 7 * m + 114) % 31) + 1;

    // Algoritmus výše spočítá Velikonoční neděli.
    // Pro české státní svátky potřebujeme Velký pátek a Velikonoční pondělí.
    const friday = new Date(year, month - 1, day - 2);
    const monday = new Date(year, month - 1, day + 1);

    return [
        localDateKey(friday), // Velký pátek
        localDateKey(monday), // Velikonoční pondělí
    ];
}

function localDateKey(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');

    return `${y}-${m}-${d}`;
}

function toMinutes(time) {
    if (!time) return null;

    const [h, m] = time.split(':');

    return parseInt(h, 10) * 60 + parseInt(m || '0', 10);
}

function getSupportHoursForToday() {
    const now = new Date();
    const year = now.getFullYear();
    const today = localDateKey(now);
    const weekday = now.getDay() === 0 ? 7 : now.getDay();

    if (manualExtendedHours[today]) {
        return manualExtendedHours[today];
    }

    if (manualClosedDays[today]) {
        return null;
    }

    const holidays = [...fixedHolidays(year), ...getEasterDates(year)];

    if (holidays.includes(today)) {
        return null;
    }

    return supportHours[weekday] || null;
}

function isSupportOnline(hours) {
    if (!hours) return false;

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const open = toMinutes(hours.open);
    const close = toMinutes(hours.close);

    return currentMinutes >= open && currentMinutes < close;
}

function isHoliday(date) {
    const year = date.getFullYear();
    const iso = localDateKey(date);
    const holidays = [...fixedHolidays(year), ...getEasterDates(year)];

    return holidays.includes(iso);
}

function isWorkingDay(date) {
    const day = date.getDay();

    return day !== 0 && day !== 6 && !isHoliday(date);
}

function afterDeliveryCutoff(now) {
    const [h, m] = deliveryHours.split(':').map(Number);

    return now.getHours() * 60 + now.getMinutes() >= (h * 60 + m);
}

function addWorkingHours(startDate, hoursToAdd) {
    const date = new Date(startDate);
    let remaining = hoursToAdd;

    while (remaining > 0) {
        date.setHours(date.getHours() + 1);

        if (isWorkingDay(date)) {
            remaining--;
        }
    }

    return date;
}

function formatDeliveryDate(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const target = new Date(date);
    target.setHours(0, 0, 0, 0);

    const diffDays = Math.round((target - today) / (1000 * 60 * 60 * 24));

    const day = date.getDate();
    const month = date.getMonth() + 1;

    if (diffDays === 1) return `zítra ${day}. ${month}. u vás`;
    if (diffDays === 2) return `pozítří ${day}. ${month}. u vás`;

    return `${day}. ${month}. u vás`;
}
const normalizedDeliveryMap = Object.keys(deliveryMap).reduce(function (acc, key) {
    acc[normalizeAvailability(key)] = deliveryMap[key];
    return acc;
}, {});


function getDeliveryDateByAvailability(availabilityText) {
    const key = normalizeAvailability(availabilityText);
    const hours = normalizedDeliveryMap[normalizeAvailability(availabilityText)];
   // console.log(key)
   // console.log(hours)
    if (!hours) return null;

    const now = new Date();

    if (afterDeliveryCutoff(now)) {
        do {
            now.setDate(now.getDate() + 1);
        } while (!isWorkingDay(now));

        now.setHours(9, 0, 0, 0);
    }

    return addWorkingHours(now, hours);
}

function getOpeningHoursForDate(date) {
    const iso = localDateKey(date);
    const weekday = date.getDay() === 0 ? 7 : date.getDay();
    const year = date.getFullYear();

    // 1) Ručně zavřená prodejna
    if (
        typeof personalPickupClosedDays !== 'undefined' &&
        personalPickupClosedDays[iso]
    ) {
        return null;
    }

    // 2) Ruční extra otevírací doba prodejny
    if (
        typeof personalPickupExtraHours !== 'undefined' &&
        personalPickupExtraHours[iso]
    ) {
        return personalPickupExtraHours[iso];
    }

    // 3) Svátky
    const holidays = [...fixedHolidays(year), ...getEasterDates(year)];

    if (holidays.includes(iso)) {
        return null;
    }

    // 4) Běžná otevírací doba prodejny / fallback na supportHours
    if (typeof personalPickupHours !== 'undefined' && personalPickupHours[weekday]) {
        return personalPickupHours[weekday];
    }

    if (typeof supportHours !== 'undefined' && supportHours[weekday]) {
        return supportHours[weekday];
    }

    return null;
}

function isPickupOpenDay(date) {
    return !!getOpeningHoursForDate(date);
}

function cloneDate(date) {
    return new Date(date.getTime());
}

function startOfDay(date) {
    const d = cloneDate(date);
    d.setHours(0, 0, 0, 0);

    return d;
}

function addDays(date, days) {
    const d = cloneDate(date);
    d.setDate(d.getDate() + days);

    return d;
}

function getNextPickupOpenDay(fromDate) {
    let date = addDays(startOfDay(fromDate), 1);
    let safetyLimit = 370;

    while (!isPickupOpenDay(date) && safetyLimit > 0) {
        date = addDays(date, 1);
        safetyLimit--;
    }

    if (safetyLimit <= 0) {
        console.warn('Nepodařilo se najít další otevřený den pro osobní odběr.');
        return null;
    }

    return date;
}

function isBeforePickupCutoff(now, hours) {
    if (!hours) return false;

    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const pickupCutoff = toMinutes(personalPickupSettings.cutoff);
    const close = toMinutes(hours.close);

    // Rozhoduje dřívější čas: 17:00 nebo výjimečná zavíračka prodejny.
    const effectiveCutoff = close ? Math.min(pickupCutoff, close) : pickupCutoff;

    return currentMinutes < effectiveCutoff;
}

function getPersonalPickupDate(now = new Date()) {
    const todayHours = getOpeningHoursForDate(now);

    if (todayHours && isBeforePickupCutoff(now, todayHours)) {
        return startOfDay(now);
    }

    return getNextPickupOpenDay(now);
}

function formatPersonalPickupDate(date, now = new Date()) {
    const today = startOfDay(now);
    const target = startOfDay(date);
    const diffDays = Math.round((target - today) / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
        return 'Ještě dnes';
    }

    if (diffDays === 1) {
        return 'K vyzvednutí zítra';
    }

    return `K vyzvednutí ${target.getDate()}. ${target.getMonth() + 1}. ${target.getFullYear()}`;
}

function getPersonalPickupHtml() {
    const pickupDate = getPersonalPickupDate();
    const label = pickupDate
        ? formatPersonalPickupDate(pickupDate)
        : 'Termín vyzvednutí upřesníme';

    return `
        <div class="personalPickupEta">
            <span class="show-tooltip question-tooltip" title="${personalPickupSettings.infoText}" data-original-title="${personalPickupSettings.infoText}">i</span>
            <span class="customDateDelivery">${label}</span>
        </div>
    `;
}

function findPersonalPickupTargets() {
    return $(personalPickupSettings.targetSelector);
}

function updatePersonalPickupStatus() {
    const html = getPersonalPickupHtml();
    const $targets = findPersonalPickupTargets();

    $targets.each(function () {
        const $target = $(this);
        const $existing = $target.find('.personalPickupEta').first();

        if ($existing.length) {
            $existing.replaceWith(html);
        } else {
            $target.append(html);
        }
    });
}

function normalizeAvailability(value) {
    return String(value || '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ');
}


